import React from "react";

const WatersVariantA = () => {
  return (
    <div className="space-y-5">
      {/* Partner Badge */}
      <div className="inline-flex items-center gap-1.5 bg-lightPurple text-purpleDark text-sm font-semibold px-3 py-1.5 rounded-full">
        <span>⭐</span> Waters Member Benefit
      </div>

      {/* Headline */}
      <div>
        <h1 className="font-montserrat text-[28px] leading-tight font-bold text-gray-900">
          Stop letting Big Tech profit from your insurance search.
        </h1>
        <p className="text-base text-gray-600 mt-3">
          Every time you searched for insurance online, your data was sold. Ownli flips the model — agencies pay <em>you</em>.
        </p>
      </div>

      {/* Stats + Callout Container */}
      <div className="border border-gray-200 rounded-2xl overflow-hidden">
        {/* Stats Row */}
        <div className="flex divide-x divide-gray-200">
          <div className="flex-1 bg-white p-4">
            <p className="font-montserrat text-3xl font-bold text-darkPurple">$1,000+</p>
            <p className="text-xs text-gray-500 mt-1">Potential annual savings</p>
          </div>
          <div className="flex-1 bg-white p-4">
            <p className="font-montserrat text-3xl font-bold text-darkPurple">$3</p>
            <p className="text-xs text-gray-500 mt-1">Earned for your data</p>
          </div>
        </div>
        {/* Purple Callout */}
        <div className="bg-lightPurple p-4 flex gap-2">
          <span className="text-base leading-5">✨</span>
          <p className="text-sm text-purpleDark">
            That $3 is yours — the <strong>first time ever a consumer gets paid for their insurance interest instead of Big Tech.</strong>
          </p>
        </div>
      </div>

      {/* Steps */}
      <div className="bg-lightGrey rounded-2xl p-5">
        <h2 className="text-xs font-bold tracking-widest text-gray-900 mb-4 uppercase">
          Here's what to expect
        </h2>
        <div className="space-y-3">
          {[
            "Sign up to create your Ownli account",
            "Complete your Insurance Profile (~5 min)",
            "Agencies compete — you get matched",
            "See real offers and collect your earnings",
          ].map((step, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="mt-1.5 min-w-[10px] min-h-[10px] bg-darkPurple rounded-full"></span>
              <p className="text-sm text-darkGrey">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WatersVariantA;
